import { ZoomLevel } from '../../components/Header/ZoomLevelMenu';

export type ZoomProps = {
  showSignals: boolean;
  signalThreshold: number;
};

interface ZoomLevels<T> {
  [ZoomLevel.COMPACT]: T;
  [ZoomLevel.STANDARD]: T;
  [ZoomLevel.DETAILED]: T;
}

const zoomProps: ZoomLevels<ZoomProps> = {
  [ZoomLevel.COMPACT]: {
    showSignals: false,
    signalThreshold: 0
  },
  [ZoomLevel.STANDARD]: {
    showSignals: true,
    signalThreshold: 4
  },
  [ZoomLevel.DETAILED]: {
    showSignals: true,
    signalThreshold: 4
  }
};

export const getZoomLevelProps = (enabled: boolean, level: ZoomLevel) =>
  zoomProps[enabled ? level : ZoomLevel.STANDARD];
